export const translation = {
    components: {
        app: {
            title: "Live Unit Admin",
        },
        mfaNotification: {
            stepOneTitle: "Multi-factor authentication coming.",
            stepOneBody: "MFA will be strictly enforced over the next 4 weeks. Please enroll today!",
            stepTwoTitle: "Verification methods",
            stepTwoBody: "Select a method to verify your identity during login.",
            remindMeLaterButton: "Remind Me Later",
            startSetupButton: "Start Setup",
            voiceSMS: "Voice/SMS",
            passkey: "Passkey",
            googleAuthenticator: "Google Authenticator",
        },
        liveUnitMosaicPage: {
            loading: "$t(common.loading)",
            errors: {
                getLiveUnitStreamData: "Failed to get Live Unit Camera Stream",
                getAlert: "Failed to get Alert information",
                realtimeEvents:
                    "Your system is trying to reconnect. Check your internet connection. If the problem persists please refresh the page.",
                resolveFailed: "Failed to resolve alert: {{message}}",
                toggleFailed: "Failed to toggle light: {{message}}",
            },
            liveUnitViewers: {
                accessMessage: {
                    cameraControl: "You have camera access",
                    viewOnly: "You are view only",
                },
                accessTag: {
                    viewOnly: "View Only",
                    cameraControl: "Camera Control",
                },
                title: "Viewers in Alert",
                viewers: "Viewers",
            },
            footer: {
                live: "LIVE",
                goToAlerts: "Go To Alert",
                buttons: {
                    lights: "Lights",
                },
            },
        },
        alerts: {
            alertsPage: {
                title: "Alerts",
                noAlerts: {
                    header: "Relax",
                    message: "Your alerts are all resolved.",
                },
                errors: {
                    realtimeEvents:
                        "Your system is trying to reconnect. Check your internet connection. If the problem persists please refresh the page.",
                },
            },
            alertItem: {
                alertSubject: {
                    person: "$t(common.alerts.alertSubject.person)",
                    vehicle: "$t(common.alerts.alertSubject.vehicle)",
                    object: "$t(common.alerts.alertSubject.object)",
                },
                alertType: {
                    lowvoltagedisconnect: "$t(common.alerts.alertType.lowvoltagedisconnect)",
                    powerloss: "$t(common.alerts.alertType.powerloss)",
                    mastmovement: "$t(common.alerts.alertType.mastmovement)",
                    baseentry: "$t(common.alerts.alertType.baseentry)",
                    headentry: "$t(common.alerts.alertType.headentry)",
                    intrusion: "$t(common.alerts.alertType.intrusion)",
                    loitering: "$t(common.alerts.alertType.loitering)",
                    gunshot: "$t(common.alerts.alertType.gunshot)",
                    fire: "$t(common.alerts.alertType.fire)",
                    Test: "$t(common.alerts.alertType.Test)",
                    other: "$t(common.alerts.alertType.other)",
                },
                alertTypeDefault: "$t(common.alerts.alertTypeDefault)",
                resolve: "Resolve",
            },
            resolveDialog: {
                title: "Resolve Alert",
                errors: {
                    noteRequired: "A note is required if 'Other' is selected",
                    tagRequired: "A tag is required",
                    resolveFailed: "Failed to resolve alert: {{message}}",
                },
                toast: {
                    resolveSuccess: "Resolve alert {{alertId}} request sent",
                },
                tags: {
                    accident: "Accident",
                    animal: "Animal",
                    deterredCrime: "Deterred Crime",
                    employeeVendor: "Employee/Vendor",
                    loitering: "Loitering",
                    suspiciousActivity: "Suspicious Activity",
                    tampering: "Tampering",
                    theft: "Theft",
                    technicalIssue: "Technical Issue",
                    violence: "Violence",
                    other: "Other",
                },
                alertSubject: {
                    person: "$t(common.alerts.alertSubject.person)",
                    vehicle: "$t(common.alerts.alertSubject.vehicle)",
                    object: "$t(common.alerts.alertSubject.object)",
                },
                alertType: {
                    lowvoltagedisconnect: "$t(common.alerts.alertType.lowvoltagedisconnect)",
                    powerloss: "$t(common.alerts.alertType.powerloss)",
                    mastmovement: "$t(common.alerts.alertType.mastmovement)",
                    baseentry: "$t(common.alerts.alertType.baseentry)",
                    headentry: "$t(common.alerts.alertType.headentry)",
                    intrusion: "$t(common.alerts.alertType.intrusion)",
                    loitering: "$t(common.alerts.alertType.loitering)",
                    gunshot: "$t(common.alerts.alertType.gunshot)",
                    fire: "$t(common.alerts.alertType.fire)",
                    Test: "$t(common.alerts.alertType.Test)",
                    other: "$t(common.alerts.alertType.other)",
                },
                alertTypeDefault: "$t(common.alerts.alertTypeDefault)",
                note: "Note",
                resolveAlert: "Resolve Alert",
            },
            alertFooter: {
                alertType: {
                    lowvoltagedisconnect: "$t(common.alerts.alertType.lowvoltagedisconnect)",
                    powerloss: "$t(common.alerts.alertType.powerloss)",
                    mastmovement: "$t(common.alerts.alertType.mastmovement)",
                    baseentry: "$t(common.alerts.alertType.baseentry)",
                    headentry: "$t(common.alerts.alertType.headentry)",
                    intrusion: "$t(common.alerts.alertType.intrusion)",
                    loitering: "$t(common.alerts.alertType.loitering)",
                    gunshot: "$t(common.alerts.alertType.gunshot)",
                    fire: "$t(common.alerts.alertType.fire)",
                    Test: "$t(common.alerts.alertType.Test)",
                    other: "$t(common.alerts.alertType.other)",
                },
                alertTypeDefault: "$t(common.alerts.alertTypeDefault)",
            },
            alertTimelineFooter: {
                resolve: "Resolve",
                resolved: "Resolved",
                goLive: "Go Live",
            },
            alertMediaTile: {
                cameraRole: {
                    Right: "Right",
                    Left: "Left",
                    Primary: "Primary",
                    Radar: "Radar",
                    None: "None",
                },
            },
            cameraStreamTile: {
                actionButtons: {
                    snapshot: "Snapshot saved to Downloads",
                    presets: {
                        newPreset: "New",
                        settings: "Settings",
                        title: "Presets",
                    },
                },
                errors: {
                    checkIn: "Check in Failed",
                    addPreset: "Failed to add preset",
                    updatePreset: "Failed to update preset",
                    snapshot: "Failed to take snapshot",
                },
            },
        },
        loading: {
            loading: "$t(common.loading)",
        },
        requestedVideos: {
            previouslyRequestedVideos: "Previously Requested Videos",
            thermal: "Thermal",
            camera: "Camera",
            panoDewarped: "Pano (Dewarped)",
            recorded: "Recorded",
            requested: "Requested",
            requestedBy: "Requested By",
            timezone: "TZ",
            utcAppendment: "UTC",
            linkPopper: "Link Copied — It will expire in 30 days",
            errors: {
                shareLink: "Failed to generate link: video_id {{videoId}}",
                download: "Failed to download video",
            },
        },
        streamContent: {
            lightsButton: {
                lights: "Lights",
            },
        },
    },
    common: {
        loading: "Loading...",
        failure: {
            head: "Something went wrong...",
            body: "Please try refreshing your page. If the problem persists please email support@lvt.com or call 888-588-9408",
        },
        alerts: {
            alertSubject: {
                person: "Person",
                vehicle: "Vehicle",
                object: "Object",
            },
            alertType: {
                lowvoltagedisconnect: "Low Voltage Disconnect",
                powerloss: "Powerloss",
                mastmovement: "Mast Movement",
                baseentry: "Base Entry",
                headentry: "Head Entry",
                intrusion: "Intrusion",
                loitering: "Loitering",
                gunshot: "Gunshot",
                fire: "Fire",
                Test: "Test",
                other: "Other",
            },
            alertTypeDefault: "Alert",
        },
    },
};
